import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  breadcrumb?: string[];
  actions?: ReactNode;
}

// Mirrors the legacy ContentTitle (page-header-breadcrumb): centered page-title
// (flex-fill) + breadcrumb on the right, in one row.
export function PageHeader({ title, breadcrumb, actions }: PageHeaderProps) {
  return (
    <div className="d-md-flex d-block align-items-center justify-content-between my-3 page-header-breadcrumb">
      <h1 className="page-title fw-semibold fs-20 mb-0 flex-fill text-center">{title}</h1>
      {breadcrumb && breadcrumb.length > 0 && (
        <div className="ms-md-1 ms-0">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              {breadcrumb.map((crumb, i) => {
                const active = i === breadcrumb.length - 1;
                return (
                  <li
                    key={`${crumb}-${i}`}
                    className={`breadcrumb-item${active ? ' active' : ''}`}
                    aria-current={active ? 'page' : undefined}
                  >
                    {crumb}
                  </li>
                );
              })}
            </ol>
          </nav>
        </div>
      )}
      {actions && <div className="ms-md-2 d-flex gap-2">{actions}</div>}
    </div>
  );
}
